module.exports = new __parcel__URL__("Mageskill_41.9eb129e4.png").toString();